import React, { lazy, Suspense } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';

import { Leyden } from '@els/els-react--leyden';

import AppLayout from 'components/layout/AppLayout';
import { ROUTES } from 'constants/routes.constants';
import RequireAuth from 'features/auth/components/RequireAuth';

const DashboardPage = lazy(() => import('features/dashboard/components/pages/DashboardPage'));
const RosterPage = lazy(() => import('features/roster/components/pages/RosterPage'));
const ProgramPage = lazy(() => import('features/program/components/pages/ProgramPage'));
const WatchlistPage = lazy(() => import('features/watchlist/components/pages/WatchlistPage'));
const StudentDetailPage = lazy(() => import('features/student/components/pages/StudentDetailPage'));

const App = () => (
  <Leyden>
    <HashRouter>
      <RequireAuth>
        <AppLayout>
          <Suspense fallback={<div className="app-loading">Loading...</div>}>
            <Routes>
              <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
              <Route path={ROUTES.ROSTER} element={<RosterPage />} />
              <Route path={ROUTES.PROGRAM} element={<ProgramPage />} />
              <Route path={ROUTES.WATCHLIST} element={<WatchlistPage />} />
              <Route path={ROUTES.STUDENT_DETAIL} element={<StudentDetailPage />} />
              <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
            </Routes>
          </Suspense>
        </AppLayout>
      </RequireAuth>
    </HashRouter>
  </Leyden>
);

export default App;
